// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import productMng from './metaData/product'
export default {
  state: productMng,
  actions
}
